import React from "react";

export function Hinge(props) {
  const {classes = ''} = props;

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 29 30"
    >
      <path
        fill="#21A0F9"
        d="M15.37 10.714l-1.15 4.29 7.253-4.187-4.187-7.252-1.15 4.29C9.816 6.16 3.326 9.909 1.632 16.229a11.74 11.74 0 00.141 6.566l2.647-1.528a8.69 8.69 0 01.072-4.272c1.268-4.733 6.145-7.549 10.878-6.28zM21.31 22.681a5.505 5.505 0 01-5.236 3.804H1.923a1.48 1.48 0 100 2.96h16.302a5.505 5.505 0 005.236-3.803l5.038-15.505a1.48 1.48 0 00-2.816-.915L21.31 22.681z"
      ></path>
    </svg>
  );
}

export function Instructions(props) {
  const {classes = ''} = props;

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 27 21"
    >
      <path
        fill="#07B018"
        fillRule="evenodd"
        d="M19.643.5c1.393 0 2.845.179 4.166.595.893.298 1.667.655 2.381 1.19v17.382c0 .297-.297.595-.595.595-.119 0-.178 0-.297-.06-1.667-.893-3.69-1.25-5.655-1.25-2.024 0-4.94.774-6.548 1.786-1.726-1.31-4.226-1.786-6.547-1.786-1.727 0-4.048.536-5.655 1.31a.44.44 0 00-.149.03c-.045.014-.09.03-.149.03-.297 0-.595-.298-.595-.596V2.286C1.726.976 4.226.5 6.548.5c2.321 0 4.821.476 6.547 1.786C14.821.976 17.321.5 19.643.5zm0 16.071c1.428 0 2.857.179 4.166.596V3.477c-1.309-.417-2.738-.596-4.166-.596-2.024 0-4.94.774-6.548 1.786v13.69c1.607-1.012 4.524-1.786 6.548-1.786z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export function Render(props) {
  const {classes = ''} = props;

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 29 27"
    >
      <path
        fill="#F2B90B"
        fillRule="evenodd"
        d="M25.714 3.357h-4.528L18.57.5H10L7.386 3.357H2.857A2.856 2.856 0 000 6.214v17.143a2.856 2.856 0 002.857 2.857h22.857a2.856 2.856 0 002.857-2.857V6.214a2.856 2.856 0 00-2.857-2.857zM14.286 7.643c2.328 0 4.378 1.136 5.685 2.857h-5.685A4.29 4.29 0 0010 14.786c0 .507.1.978.264 1.428H7.286a7.146 7.146 0 017-8.571zM8.607 19.07c1.3 1.729 3.35 2.858 5.679 2.858a7.145 7.145 0 007-8.572h-2.979c.164.45.264.929.264 1.429a4.29 4.29 0 01-4.285 4.285H8.607z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export function Decal(props) {
  const {classes = ''} = props;

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 27 25"
    >
      <path
        fill="#21A0F9"
        d="M7.5 2c-1.655 0-3 1.345-3 3v10.5c0 1.655 1.345 3 3 3H24c1.655 0 3-1.345 3-3V5c0-1.655-1.345-3-3-3H7.5zm11.063 5.002l4.5 6.75c.23.346.253.787.056 1.153a1.128 1.128 0 01-.994.595H9.375a1.125 1.125 0 01-.877-1.828l3-3.75a1.123 1.123 0 011.754 0l.81 1.012 2.626-3.937a1.13 1.13 0 011.875.005zM9 6.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm-6.75-.375C2.25 5.502 1.748 5 1.125 5S0 5.502 0 6.125v10.5A6.376 6.376 0 006.375 23h15c.623 0 1.125-.502 1.125-1.125s-.502-1.125-1.125-1.125h-15a4.125 4.125 0 01-4.125-4.125v-10.5z"
      ></path>
    </svg>
  );
}

export function Palette(props) {
  const {classes = ''} = props;

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 28 29"
    >
      <path
        fill="#07B018"
        d="M25.37 14.62c0 .148-.055.285-.23.438-.207.17-.552.317-.973.317H18.81a5.25 5.25 0 00-5.134 6.333c.18.858.557 1.7.787 2.22.038.088.077.164.104.235.273.63.306.843.306.935 0 .29-.104.52-.208.646a.371.371 0 01-.109.098.22.22 0 01-.088.022c-.158.005-.311.011-.47.011-6.282 0-11.373-5.091-11.373-11.375S7.714 3.125 13.997 3.125c6.283 0 11.373 5.091 11.373 11.375v.12zm2.624.028V14.5c0-7.733-6.265-14-13.997-14C6.266.5 0 6.767 0 14.5s6.266 14 13.997 14c.192 0 .389-.006.58-.01 1.739-.072 2.92-1.647 2.92-3.392 0-.793-.334-1.547-.662-2.296-.235-.536-.476-1.078-.59-1.636A2.625 2.625 0 0118.814 18h5.352c1.996 0 3.811-1.356 3.833-3.352h-.006zM8.748 14.5a1.75 1.75 0 10-3.5 0 1.75 1.75 0 003.5 0zm0-3.5a1.75 1.75 0 100-3.499 1.75 1.75 0 000 3.499zm6.999-3.5a1.75 1.75 0 10-3.5 0 1.75 1.75 0 003.5 0zm3.5 3.5a1.75 1.75 0 100-3.499 1.75 1.75 0 000 3.499z"
      ></path>
    </svg>
  );
}

export function Export(props) {
  const {classes = ''} = props;

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 27 25"
    >
      <path
        fill="#F2B90B"
        d="M0 3.5c0-1.655 1.345-3 3-3h7.5v6c0 .83.67 1.5 1.5 1.5h6v6h-7.875C9.502 14 9 14.502 9 15.125s.502 1.125 1.125 1.125H18v5.25c0 1.655-1.345 3-3 3H3c-1.655 0-3-1.345-3-3v-18zm18 12.75V14h5.16l-1.827-1.828a1.125 1.125 0 011.59-1.59l3.749 3.75c.44.441.44 1.154 0 1.59l-3.75 3.75a1.125 1.125 0 01-1.59-1.59l1.829-1.827H18v-.005zm0-9.75h-6v-6l6 6z"
      ></path>
    </svg>
  );
}

export function Connectivity(props) {
  const {classes = ''} = props;

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 28 25"
    >
      <path
        fill="#EE2E20"
        d="M8.56 20.5c0-1.013-.4-1.92-1.027-2.613l5.534-9.507c.306.067.613.12.933.12.32 0 .627-.053.933-.12l5.48 9.4a3.983 3.983 0 00-1.08 2.72c0 2.213 1.787 4 4 4 2.214 0 4-1.787 4-4s-1.786-4-4-4c-.32 0-.626.053-.933.12l-5.48-9.4A3.983 3.983 0 0018 4.5c0-2.213-1.787-4-4-4s-4 1.787-4 4c0 1.053.413 2 1.08 2.72l-5.547 9.493a3.765 3.765 0 00-.866-.106A3.898 3.898 0 00.773 20.5a3.898 3.898 0 003.894 3.893A3.898 3.898 0 008.56 20.5z"
      ></path>
    </svg>
  );
}